import { connect } from 'react-redux';
import InputModalSemiProduct from './InputModalSemiProduct';

const mapStateToProps = ({
  userReducer,
  tabsReducer,
  inputOperationReducer
}) => ({
  userReducer,
  tabsReducer,
  inputOperationReducer
});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InputModalSemiProduct);
